import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';

const ThemeElevenTitle = props => {
  const operator = props.operator || props.home.operator;
  return (
    <div
      id={props.id}
      className={`themes-theme-eleven-title new-container  ${props.className}`}
      style={props.containerStyle ? props.containerStyle : { margin: '35px auto' }}
    >
      {props.smallHeading && (
        <div
          className="mb5 font18"
          style={{
            color:
              operator && operator.color_codes && operator.color_codes.primary_text_color
                ? operator.color_codes.primary_text_color
                : null,
            marginRight: 5,
          }}
        >
          {props.smallHeading}
        </div>
      )}

      {props.boldHeading && (
        <div
          className="bold-text mb5 font18"
          style={{
            color:
              operator && operator.color_codes && operator.color_codes.primary_text_color
                ? operator.color_codes.primary_text_color
                : null,
          }}
        >
          {props.boldHeading}
        </div>
      )}
    </div>
  );
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeElevenTitle);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/components/ThemeElevenTitle.js